import { z } from "zod";

import {
  DateTimeString,
  getDateTimeString,
  zDateTimeString,
} from "../../dateTypes.js";
import { AppRunState } from "../../enums.js";
import { typedObjectEntries } from "../../utils/typedObjects.js";
import { createAppSessionEventDefinition } from "../AppSessionEventDefinition.js";
import { AppSession } from "../AppSessionEventState.js";

export const UPDATE_APP_SESSION = createAppSessionEventDefinition({
  type: "UPDATE_APP_SESSION",
  payloadSchema: z.object({
    state: z.nativeEnum(AppRunState).optional(),
    totalMemory: z.string().nullish(),
    availableMemory: z.string().nullish(),
    maxMemory: z.string().nullish(),
    executionRevision: z.number().optional(),
    lastRunStart: zDateTimeString.nullish(),
    lastRunEnd: zDateTimeString.nullish(),
  }),
  logSafe: {
    state: true,
    totalMemory: true,
    availableMemory: true,
    maxMemory: true,
    lastRunStart: true,
    lastRunEnd: true,
    executionRevision: true,
  },
  create: ({
    lastRunEnd,
    lastRunStart,
    ...rest
  }: Partial<
    Omit<AppSession, "lastRunStart" | "lastRunEnd"> & {
      lastRunStart: Date | DateTimeString | null;
      lastRunEnd: Date | DateTimeString | null;
    }
  >) => ({
    lastRunStart:
      lastRunStart instanceof Date
        ? getDateTimeString(lastRunStart)
        : lastRunStart,
    lastRunEnd:
      lastRunEnd instanceof Date ? getDateTimeString(lastRunEnd) : lastRunEnd,
    ...rest,
  }),
  apply: ({ payload, state }) => {
    for (const entry of typedObjectEntries(payload)) {
      if (entry != null) {
        //  we know that this key must match
        state.appSession[entry[0]] = entry[1] as never;
      }
    }
  },
});
